import request from "../../utils/request";

export const state = {};

export const actions = {
  getReviews({ dispatch, commit }, params) {
    return request({
      url: appUrl + "/api/company/reviews",
      params,
      callBack: (type, value) => {
        return value?.data?.data || null;
      },
    });
  },
  getRating({ dispatch, commit }, params) {
    return request({
      url: appUrl + "/api/company/rating",
      params,
      callBack: (type, value) => {
        return value?.data?.data || null;
      },
    });
  },
  getUtility({ dispatch, commit }, params) {
    return request({
      url: appUrl + "/api/company/utility",
      params,
      callBack: (type, value) => {
        return value?.data?.data || null;
      },
    });
  },
};
